import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { IOrgChannel } from './interfaces';

const basePath = '/channels';

/* eslint-disable implicit-arrow-linebreak */

export const getChannelsByOrgId = (orgId: number): AxiosPromise<IApiResponse<Array<IOrgChannel>>> =>
  vaultApi.getInstance().get(`${basePath}/org/${orgId}`);
